export default {
    "main": "Main",
    "gift": "Gift",
    "bag": "Bag",
}
